
import Vue from 'vue'

export default Vue.extend({
  model: {
    prop: 'value',
    event: 'update'
  },

  props: {
    value: {
      type: [String, Number, Boolean, Date],
      default: null
    },
    status: {
      type: Boolean,
      default: null
    },
    copy: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: [String, Object],
      default: null
    }
  }
})
